module.exports = __webpack_public_path__ + "img/video.14afa255.svg";